import Vue from 'vue';
import BzbsApi from '@/service/BzbsApi.js';
import { ProvinceModel, DistrictModel, SubDistrictModel} from '@/model/AddressModel.js';

/**
 * @method apiGetProvinceFilterByZipcode
 */
export default {
    config: function() {
        return Vue.bzbsConfig;
    },

    apiGetProvinceFilterByZipcode: function(strZipcode) {
        var params = {
            zip_code: strZipcode,
        };

        var strUrl = this.config().bzbs_url + "/main/postcode";
        return new Promise((resolve, reject) => {
            BzbsApi.connectBzbsGet(strUrl, null, params).then((response) => {
                var data = response.data;
                var listProvince = [];
                var listDistrict = [];
                var listSubDistrict = [];

                for (var i = 0; i < data.length; i++) {
                    // Add List Province
                    var prov = new ProvinceModel(data[i]);
                    var isDuplicateProvince = false;
                    for (var j = 0; j < listProvince.length; j++) {
                        if (listProvince[j].provinceNameEN == prov.provinceNameEN) {
                            isDuplicateProvince = true;
                            break;
                        }
                    }

                    if (!isDuplicateProvince) {
                        listProvince.push(prov);
                    }

                    // Add List District
                    var dis = new DistrictModel(data[i]);
                    var isDuplicateDistrict = false;
                    for (var k = 0; k < listDistrict.length; k++) {
                        if (listDistrict[k].districtNameEN == dis.districtNameEN) {
                            isDuplicateDistrict = true;
                            break;
                        }
                    }

                    if (!isDuplicateDistrict) {
                        listDistrict.push(dis);
                    }

                    // Add List SubDistrict
                    var subDis = new SubDistrictModel(data[i]);
                    var isDuplicateSubDistrict = false;
                    for (var l = 0; l < listSubDistrict.length; l++) {
                        if (listSubDistrict[l].subdistrictNameEN == subDis.subdistrictNameEN) {
                            isDuplicateSubDistrict = true;
                            break;
                        }
                    }

                    if (!isDuplicateSubDistrict) {
                        listSubDistrict.push(subDis);
                    }
                }

                if (listProvince.length > 0) {
                    var allAddress = {
                        listProvince: listProvince,
                        listDistrict: listDistrict,
                        listSubDistrict: listSubDistrict,
                    };
                    resolve(allAddress);
                } else {
                    reject('notfound');
                }
            }).catch((error) => {
                reject(error);
            });
        });
    },
}
